// Іконки сторінки розіграшів; колір беруть з теми через currentColor.

export const TicketIcon = () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M2 9a3 3 0 010 6v2a2 2 0 002 2h16a2 2 0 002-2v-2a3 3 0 010-6V7a2 2 0 00-2-2H4a2 2 0 00-2 2z" />
        <path d="M13 5v2M13 11v2M13 17v2" />
    </svg>
);

export const CheckIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M5 12l5 5 9-10" />
    </svg>
);

export const LockIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <rect x="5" y="11" width="14" height="10" rx="2" />
        <path d="M8 11V8a4 4 0 018 0v3" />
    </svg>
);

export const GiftIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M4 11h7v10H5a1 1 0 01-1-1zM13 11h7v9a1 1 0 01-1 1h-6z" />
        <path d="M3 8a1 1 0 011-1h7v3H3zM13 7h7a1 1 0 011 1v2h-8z" />
        <path d="M11.4 6.6C10 3.4 6.4 2.9 6.4 5.3c0 1.6 2.2 1.7 5 1.3zM12.6 6.6c1.4-3.2 5-3.7 5-1.3 0 1.6-2.2 1.7-5 1.3z" />
    </svg>
);

// значок типу розіграшу
export const TypeIcon = ({ type }: { type: string }) => {
    if (type === "priority") {
        return (
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M3 8l4.5 4L12 5l4.5 7L21 8l-2 11H5L3 8z" />
            </svg>
        );
    }
    if (type === "set") {
        return (
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M12 3l8 4v5c0 5-3.5 8-8 9-4.5-1-8-4-8-9V7z" />
            </svg>
        );
    }
    return (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <circle cx="9" cy="8" r="3.5" />
            <path d="M2.5 20c.8-3.6 3.4-5.5 6.5-5.5s5.7 1.9 6.5 5.5" />
            <circle cx="17" cy="9" r="2.5" />
            <path d="M16 14.6c2.7 0 4.8 1.6 5.5 4.4" />
        </svg>
    );
};
